import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { AssetService } from 'src/app/_services/asset.service';

@Component({
  selector: "app-reorder-types",
  templateUrl: "./reorder-types.component.html",
  styleUrls: ["./reorder-types.component.scss"],
  standalone: false,
})
export class ReorderTypesComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  inActiveJOTypes: any[] = [];
  inActiveJOStatuses: any[] = [];
  inActiveAssetTypes: any[] = [];
  inActiveAssetStatuses: any[] = [];

  joTypeData: any;
  joStatusData: any;
  assetTypeData: any;
  assetStatusData: any;

  constructor(
    public modalRef: BsModalRef,
    private bsModalServc: BsModalService,
    private languageTranslateService: LanguageTranslateService,
    private globalJOServc: GlobalJobordersService,
    private errorUtil: ErrorUtil,
    private assetService: AssetService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    if (this.data.module == "joType") {
      this.joTypeData = this.data.data;
      this.inActiveJOTypes = this.data.data.filter((item: any) => {
        return item.active === false;
      });
      this.joTypeData = this.data.data.filter((item: any) => {
        return item.active === true;
      });
    } else if (this.data.module == "assetType") {
      this.assetTypeData = this.data.data;
      this.inActiveAssetTypes = this.data.data.filter((item: any) => {
        return item.active === false;
      });
      this.assetTypeData = this.data.data.filter((item: any) => {
        return item.active === true;
      });
    } else if (this.data.module == "assetStatus") {
      this.assetStatusData = this.data.data;
      this.inActiveAssetStatuses = this.data.data.filter((item: any) => {
        return item.active !== true;
      });
      this.assetStatusData = this.data.data.filter((item: any) => {
        return item.active === true;
      });
    } else {
      //jo status reorder
      this.joStatusData = this.data.data;
      this.inActiveJOStatuses = this.data.data.filter((item: any) => {
        return item.active !== true;
      });
      this.joStatusData = this.data.data.filter((item: any) => {
        return item.active === true;
      });
    }

    console.log(this.data, "data printing in re order component");
    this.data.data.sort((a: any, b: any) => a.order - b.order);
    this.data.data.map((item: any) => {
      item["disabled"] = item.isDefault ? false : true; //only one default value is allowed. Thus, disable others
    });
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  onActiveToggle(
    joType: any,
    index: number,
    statusType: string,
    module: string,
  ) {
    if (module == "joType") {
      if (statusType === "active") {
        //add the item to inactive list's first position
        joType.active = false;
        this.inActiveJOTypes.unshift(joType);
        //remove it from active list
        this.data.data = this.data.data.filter((item: any) => {
          return item.id !== joType.id;
        });
        this.joTypeData.splice(index, 1);
        this.joTypeData.sort((a: any, b: any) => a.order - b.order);
      } else {
        //add the item to active list
        joType.active = true;
        this.joTypeData.push(joType);
        this.joTypeData.sort((a: any, b: any) => a.order - b.order);
        //remove it from inactive list
        this.inActiveJOTypes = this.inActiveJOTypes.filter((item: any) => {
          return item.id !== joType.id;
        });
      }
    } else if (module == "assetType") {
      if (statusType === "active") {
        //add the item to inactive list's first position
        joType.active = false;
        this.inActiveAssetTypes.unshift(joType);
        //remove it from active list
        this.data.data = this.data.data.filter((item: any) => {
          return item.id !== joType.id;
        });
        this.assetTypeData.splice(index, 1);
        this.assetTypeData.sort((a: any, b: any) => a.order - b.order);
      } else {
        //add the item to active list
        joType.active = true;
        this.assetTypeData.push(joType);
        this.assetTypeData.sort((a: any, b: any) => a.order - b.order);
        //remove it from inactive list
        this.inActiveAssetTypes = this.inActiveAssetTypes.filter(
          (item: any) => {
            return item.id !== joType.id;
          },
        );
      }
    } 
    else if (module == 'assetStatus'){
      if (statusType === "active") {
        //add the item to inactive list
        joType.active = false;
        this.inActiveAssetStatuses.push(joType);
        //remove it from active list
        this.assetStatusData.splice(index, 1);
        this.assetStatusData.sort((a: any, b: any) => a.order - b.order);
        this.data.data = this.data.data.filter((item: any) => {
          return item.id !== joType.id;
        });
      } else {
        //add the item to active list
        joType.active = true;
        //this.data.data.push(joType);
        this.assetStatusData.push(joType);
        this.assetStatusData.sort((a: any, b: any) => a.order - b.order);
        //remove it from inactive list
        this.inActiveAssetStatuses = this.inActiveJOStatuses.filter(
          (item: any) => {
            return item.id !== joType.id;
          },
        );
      }
    }
    else {
      if (statusType === "active") {
        //add the item to inactive list
        joType.active = false;
        this.inActiveJOStatuses.push(joType);
        //remove it from active list
        this.joStatusData.splice(index, 1);
        this.joStatusData.sort((a: any, b: any) => a.order - b.order);
        this.data.data = this.data.data.filter((item: any) => {
          return item.id !== joType.id;
        });
      } else {
        //add the item to active list
        joType.active = true;
        //this.data.data.push(joType);
        this.joStatusData.push(joType);
        this.joStatusData.sort((a: any, b: any) => a.order - b.order);
        //remove it from inactive list
        this.inActiveJOStatuses = this.inActiveJOStatuses.filter(
          (item: any) => {
            return item.id !== joType.id;
          },
        );
      }
    }
  }

  push(obs: any) {
    super.push(obs);
  }

  onJOTypeReOrdered(event: CdkDragDrop<any[]>, module: string) {
    if (module == "joType") {
      moveItemInArray(this.joTypeData, event.previousIndex, event.currentIndex);

      this.joTypeData.forEach((item: any, index: number) => {
        item.order = index + 1;
      });
    } else if (module == "assetType") {
      moveItemInArray(
        this.assetTypeData,
        event.previousIndex,
        event.currentIndex,
      );
      this.assetTypeData.forEach((item: any, index: number) => {
        item.order = index + 1;
      });
    } 
    else if(module == "assetStatus"){
      moveItemInArray(
        this.assetStatusData,
        event.previousIndex,
        event.currentIndex,
      );
      this.assetStatusData.forEach((item: any, index: number) => {
        item.order = index + 1;
      });
    }
    else {
      moveItemInArray(
        this.joStatusData,
        event.previousIndex,
        event.currentIndex,
      );

      this.joStatusData.forEach((item: any, index: number) => {
        item.order = index + 1;
      });
    }
  }

  submitOrder() {
    let joTypes: any = [];
    this.data.data.map((item: any) => {
      joTypes.push({
        id: item.id,
        order: item.order,
        isDefault: item.isDefault,
        active: item.active,
      });
    });

    if (this.data.module == "joType") {
      this.inActiveJOTypes.sort((a: any, b: any) =>
        a.label.localeCompare(b.label),
      );
      let inactiveOrder: number = 100; //inactive order starts at 100
      this.inActiveJOTypes.map((item: any, index: number) => {
        joTypes.push({
          id: item.id,
          order: inactiveOrder + index,
          isDefault: item.isDefault,
          active: item.active,
        });
      });

      this.globalJOServc.updateJoTypeOrder(joTypes).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              3000,
            );

            this.modalRef.hide();
          }
        },
        (err: any) => {
          console.log(err, "error in PUT jo type order api");
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
    } else if (this.data.module == "assetType") {
      this.inActiveAssetTypes.sort((a: any, b: any) =>
        a.label.localeCompare(b.label),
      );
      let inactiveOrder: number = 100; //inactive order starts at 100
      this.inActiveAssetTypes.map((item: any, index: number) => {
        joTypes.push({
          id: item.id,
          order: inactiveOrder + index,
          isDefault: item.isDefault,
          active: item.active,
        });
      });

      this.assetService.updateAssetTypeOrder(joTypes).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              3000,
            );

            this.modalRef.hide();
          }
        },
        (err: any) => {
          console.log(err, "error in PUT jo type order api");
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
    } 
    else if (this.data.module == 'assetStatus'){
      this.inActiveAssetStatuses.sort((a: any, b: any) =>
        a.label.localeCompare(b.label),
      );
      let inactiveOrder: number = 100; //inactive order starts at 100
      this.inActiveAssetStatuses.map((item: any, index: number) => {
        joTypes.push({
          id: item.id,
          order: inactiveOrder + index,
          isDefault: item.isDefault,
          active: item.active,
        });
      });

      this.assetService.reorderAssetStatuses(joTypes).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              3000,
            );

            this.modalRef.hide();
          }
        },
        (err: any) => {
          console.log(err, "error in PUT asset status order api");
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
    }
    else {
      this.inActiveJOStatuses.sort((a: any, b: any) =>
        a.fieldLabel.localeCompare(b.fieldLabel),
      );
      let inactiveOrder: number = 100; //inactive order starts at 100
      this.inActiveJOStatuses.map((item: any, index: number) => {
        joTypes.push({
          id: item.id,
          order: inactiveOrder + index,
          isDefault: item.isDefault,
          active: item.active,
        });
      });

      this.globalJOServc.updateStatusOrder(joTypes).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.savedSuccessfully,
              null,
              "success",
              3000,
            );

            this.modalRef.hide();
          }
        },
        (err: any) => {
          console.log(err, "error in PUT jo status order api");
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
    }
  }

  onCancelClick() {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }
}
